import { AuthenticationForm } from "../../../components/auth/login/AuthenticationForm.tsx";

export default function LoginPage() {
  return (
    <div className="w-full h-screen">
      <AuthenticationForm />
    </div>
  );
}
